import { inject } from 'mobx-react';
import * as React from 'react';

import { ServerDrivenUiStore } from './sdui-store';

import { traverseChildren } from './utils';

import { SduiContent } from './sdui-content';

interface SduiDeclareProps {
  sdui?: ServerDrivenUiStore;
}

@inject('sdui')
export class SduiDeclare extends React.Component<SduiDeclareProps> {
  public componentWillMount() {
    const { sdui } = this.props;
    if (!sdui) {
      return;
    }

    traverseChildren(this, child => {
      if (child && child.type === SduiContent) {
        sdui.declareContent(child.props.name, child.props.children);

        return true;
      }

      return false;
    });
  }

  public render() {
    return null;
  }
}
